import React, { useContext } from 'react';
import { IconButton } from '@one-thd/sui-atomic-components';
import { TrashCan } from '@one-thd/sui-icons';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import { ProductListContext } from '../ProductListContext';

export const DeleteButton = ({ itemId, intentId, groupId, iconSize, 'data-testid': testId }) => {
  const { removeListItems, removeIntentItem, isRemoving } = useContext(ProductListContext);

  const handleDelete = () => {
    if (!isRemoving) {
      // If intentId is provided, delete the intent item
      if (intentId && removeIntentItem) {
        removeIntentItem({ groupId, intentId });
      } else if (itemId && removeListItems) {
        // Otherwise delete the regular item
        removeListItems([itemId]);
      }
    }
  };

  return (
    <IconButton
      icon={TrashCan}
      iconSize={iconSize}
      aria-label="Delete Item"
      disabled={isRemoving}
      onClick={handleDelete}
      data-testid={testId}
    />
  );
};

DeleteButton.propTypes = {
  itemId: string,
  intentId: string,
  groupId: string,
  iconSize: string
};

DeleteButton.defaultProps = {
  itemId: null,
  intentId: null,
  groupId: null,
  iconSize: 'small'
};
